export enum OperatorsActions{
    TOGGLE_OPERATORS_PANEL = "toggleOperatorsPanel",
    SET_SELECTED_OPERATOR = "setSelectedOperator"
}